<template>
    <div class="cover">
    </div>
</template>

<script>
    export default {
        name: 'LayoutCover',

        data () {
            return {};
        },
    };
</script>

<style scoped lang="scss">
    @import '~@/assets/styles/abstracts/_variables';

    .cover {
        $header-height: 35rem;
        background: $color-brand;

        min-height: $header-height;
    }
</style>
